<template>
  <div class="userService">
    <div class="header">未成年保护制度</div>
    <div class="con">
      1. 我们非常重视对未成年人个人信息的保护，任何未成年人参加网上活动应事先取得家长或其法定监护人（以下简称"监护人"）的同意。我们将根据国家相关法律法规的规定保护未成年人的相关信息。<br>

      2. 我们鼓励父母或监护人指导未成年人使用软件服务。<br>

      3. 建议未成年人在提交信息之前寻求父母或监护人的同意和指导。<br>

      4. 若你是未成年人的监护人，当您对您所监护的未成年人的个人信息有相关疑问时，请与我们取得联系<br>
    </div>

  </div>
</template>

<script setup>

</script>

<style lang="scss" scoped>
.userService {
  .header {
    font-size: 28px;
    
    color: #333333;
    line-height: 40px;
  }

  .con {
    font-size: 18px;
    font-weight: 400;font-weight: lighter;
    color: #333333;
    line-height: 36px;
    margin-top: 30px;
  }

}
</style>